<div class="hero-wrapper">
    <div class="hero-overlay"></div>

    <div class="uk-container hero-content">

        <div uk-scrollspy="cls: uk-animation-slide-left-small; delay: 100">
            <h1 class="hero-title">
                Poder de computação,<br>resiliência de dados<br>e <span class="hero-highlight">conectividade</span>
            </h1>
            <p class="hero-subtitle">Aproveite a nossa infraestrutura em nuvem de Alta
                Disponibilidade e as nossas soluções
                de conectividade resiliente para máximo desempenho dos seus projectos.</p>
        </div>

        <div class="cards-section">


            <div class="uk-container uk-margin-medium-top uk-margin-medium-bottom">
                <div class="uk-child-width-1-3@l espaco uk-child-width-1-1@s uk-grid-match uk-grid uk-text-center" uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 200">
                    <div>
                        <div class="card uk-card uk-card-body">
                            <h2 class="card-title"><b> Hospede um projecto Web </b> </h2>
                            <p class="card-description">
                                Gerencie seu site com facilidade usando o painel cPanel, a solução mais popular do
                                mercado. <br> Tenha suporte especializado e infraestrutura de alta performance para o
                                seu sucesso digital.
                            </p>

                            <div class="card-footer">
                                <a routerLink="/hosting" class="uk-border-pill uk-button uk-button-secondary"> Começar
                                    agora</a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="card uk-card uk-card-body">
                            <h2 class="card-title"><b> Registe um Domínio Web </b> </h2>
                            <p class="card-description">
                                Registe o domínio ideal para a sua marca com rapidez, extensões nacionais e
                                internacionais. <br> Proteja sua identidade digital com uma gestão simplificada e
                                renovação automática.
                            </p>
                            <div class="card-footer">
                                <a routerLink="/domain" class="uk-border-pill uk-button uk-button-secondary"> Registar
                                    agora</a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="card uk-card uk-card-body">
                            <h2 class="card-title"><b> E-mail Corporativo </b> </h2>
                            <p class="card-description">
                                Garanta maior profissionalismo para o seu negócio com e-mails personalizados e
                                seguros. <br>
                                Soluções escaláveis com suporte local e alta disponibilidade.
                            </p>
                            <div class="card-footer">
                                <a href="https://wa.me/244937754502/?text=Ol%C3%A1%2C%20estou%20interessado%20no%20E-mail%20Corporativo%2C%20pode%20me%20explicar%20os%20planos%3F"
                                    target="_blank" class="uk-border-pill uk-button uk-button-secondary">Solicitar agora</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>

</div>

